<template lang="pug">
    .play-box
        template(v-if='!isLoading')
                game-header(
                    v-if="!isBattle",
                    @soundStateChanged ="headerKey = !headerKey"
                    :key="headerKey"
                    :slug='type',
                    :game-type='parameters && parameters.courseType',
                    :is-homework="!!exerciseId",
                )
                .play-box__game-content(v-if='gameStarted && !gameFinished')
                    .play-box__center
                        .play-box__center-word
                            | {{ example.word }}
                        .play-box__center-transcription(v-if='isCorrectAnswerChosen')
                            | {{ example.transcription }}
                        cs-button.answer-button(
                            color="blue",
                            pattern="primary-outline",
                            type='button',
                            @click='(isCorrectAnswerChosen ? nextExample : processReply)()',
                        )
                            | {{ $i18n.t(isCorrectAnswerChosen ? 'trainer.trainer_gamePlayBox_further' : 'trainer.trainer_gamePlayBox_reply') }}
                        .play-box__input-container(@keyup="keyupHandler")
                            label.input__label
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_amountOfLetters') }}
                            cs-input(
                                v-focus="true"
                                type="number"
                                maxlength="2"
                                :value="amountLetters.value",
                                :disabled="amountLetters.disabled"
                                :class="{'error': amountLetters.error}"
                                @input="onChangeAmount(amountLetters, $event)",
                                )
                            label.input__label
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_amountOfSounds') }}
                            cs-input(
                                maxlength="2"
                                type="number"
                                :value="amountSounds.value",
                                :disabled="amountSounds.disabled"
                                :class="{'error': amountSounds.error}"
                                @input="onChangeAmount(amountSounds, $event)",
                                )
                            label.input__label
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_amountOfSyllables') }}
                            cs-input(
                                type="number"
                                maxlength="2"
                                :value="amountSyllables.value",
                                :disabled="amountSyllables.disabled"
                                :class="{'error': amountSyllables.error}"
                                @input="onChangeAmount(amountSyllables, $event)",
                                )
                    .game-info__block
                        game-info(
                            :score="{left: answers.good, right: answers.bad}",
                            :time="getTime"
                            :slug="type"
                            :parameters="parameters"
                            :game-allows-tips="false"
                            :opponent="opponent"
                            :opponent-numbers="opponentNumbers"
                            :is-opponent-answering="isOpponentAnswering"
                            :is-from-battle="isBattle"
                            :is-olympiad="isOlympiad"
                        )
                .play-box__end-container(v-if='gameFinished && !isOlympiad')
                    fireworks(:is-mobile="isMobile")
                    .play-box__reaction-container
                        .play-box__answers.play-box__answers--left
                            | {{ $i18n.t('trainer.trainer_game_wordField_yourTime') }}
                            br
                            | {{ getTime }}
                        result-image.play-box__image(status="success")
                        .play-box__answers.play-box__answers--right
                            | {{ $i18n.t('dashboard.dashboard_sidebar_statistics') }}
                            br
                            | {{ answers.good }} / {{ answers.bad }}
                    result-buttons(
                        v-if="!isBattle"
                        :exercise-id="exerciseId"
                        :games-type="parameters.courseType"
                        show-restart-button
                        @restartGame="restartGame"
                    )
                        slot
                calculating-answers(v-if="calculatingAnswers" :is-last-game-in-battle="isLastGameInBattle")
        cs-loader(v-else)
</template>

<script>
    /*eslint-disable*/
    import LettersSoundsSyllablesGameApi from '../../../../api/games/lettersSoundsSyllablesGameApi';
    import playBoxGameMixin from '../../../../utils/trainer/playBoxGameMixin.js';
    import Battle from '../../../../utils/battle/battleMixin';
    import olympiadRussianLanguageAnswerTimerMixin from '../../../../utils/olympiads/olympiadRussianLanguageAnswerTimerMixin.js';
    import { cloneDeep } from 'lodash';
    import CsButton from '@/elements/CsButton.vue';
    import CsLoader from '@/elements/CsLoader.vue';
    import CalculatingAnswers from '../../CalculatingAnswersModal.vue';

    function DEFAULT_DATA() {
        return {
            example: null,
            currentLevel: 0,
            isCorrectAnswerChosen: false,
            answers: { good: 0, bad: 0 },
            amountLetters: {
                value: '',
                disabled: false,
                error: false,
            },
            amountSounds: {
                value: '',
                disabled: false,
                error: false,
            },
            amountSyllables: {
                value: '',
                disabled: false,
                error: false,
            },
        };
    }

    export default {
        mixins: [playBoxGameMixin, olympiadRussianLanguageAnswerTimerMixin, Battle],
        data() {
            return DEFAULT_DATA();
        },
        mounted() {
            document.addEventListener('keydown', this.clickEnter);
        },
        destroyed() {
            document.removeEventListener('keydown', this.clickEnter);
        },
        computed: {
            isInfiniteAmountOfExamples() {
                return this.parameters.infinityAmountOfExamples;
            },
        },
        methods: {
            keyupHandler(e) {
                var target = e.srcElement;
                var maxLength = parseInt(target.attributes["maxlength"].value, 10);
                var myLength = target.value.length;
                if (myLength >= maxLength) {
                    var next = target;
                    while (next = next.nextElementSibling) {
                        if (next == null)
                            break;
                        if (next.tagName.toLowerCase() == "input") {
                            next.focus();
                            break;
                        }
                    }
                }
            },
            registerSounds() {
                this.$createjs.Sound.removeAllSounds();
                this.$createjs.Sound.removeAllEventListeners();
                this.$createjs.Sound.alternateExtensions = ['mp3', 'ogg'];
                this.$createjs.Sound.registerSounds(this.soundObjects);
            },
            fetchData() {
                this.getExercise()
                    .then(() => {
                        this.getItemPromise()
                            .then(data => {
                                this.example = data;
                                this.startGame();
                                this.registerSounds();
                                this.isLoading = false;
                            })
                            .catch(e => this.showErrorMessage(e));
                    })
                    .catch(e => {
                        this.isLoading = false;
                        this.$toasted.error(this.$root.$t('errors.getting_level'));
                        this.$router.push({ name: 'dashboard' });
                    });
            },
            getExample() {
                return this.getItemPromise()
                    .then(data => {
                        this.example = data;
                    })
                    .catch(e => this.showErrorMessage(e));
            },
            getItemPromise() {
                return LettersSoundsSyllablesGameApi.getItem({ class: this.parameters.class });
            },
            refreshGameStatBeforeSend() {
                this.gameStat.answers = this.answers.good;
                this.gameStat.amountOfMistakes = this.answers.bad;
                this.gameStat.attempts = this.parameters.amountOfExamples;
                this.gameStat.isCompleted = this.gameFinished;
                this.gameStat.executionTime = this.time;
                this.gameStat.isCorrect = true;
                this.gameStat.percent = this.calculatePercent();
                this.gameStat.amountOfExamples = this.parameters.amountOfExamples;
                this.gameStat.parameters = cloneDeep(this.parameters);
            },
            startGame() {
                this.gameStarted = true;
                this.startTimer();
            },
            startTimer() {
                this.startAnswerTimer();
                this.$nextTick(() => {
                    if (!this.timer) {
                        this.setTimer();
                    }
                });
            },
            processReply(finishExample = false) {
                if (!this.amountLetters.disabled) {
                    if (this.example.amountLetters == this.amountLetters.value) {
                        this.answers.good++;
                        this.amountLetters.disabled = true;
                    } else {
                        this.answers.bad++;
                        this.amountLetters.error = true;
                    }
                }
                if (!this.amountSounds.disabled) {
                    if (this.example.amountSounds == this.amountSounds.value) {
                        this.answers.good++;
                        this.amountSounds.disabled = true;
                    } else {
                        this.answers.bad++;
                        this.amountSounds.error = true;
                    }
                }
                if (!this.amountSyllables.disabled) {
                    if (this.example.amountSyllables == this.amountSyllables.value) {
                        this.answers.good++;
                        this.amountSyllables.disabled = true;
                    } else {
                        this.answers.bad++;
                        this.amountSyllables.error = true;
                    }
                }
                if (this.amountLetters.disabled && this.amountSounds.disabled && this.amountSyllables.disabled) {
                    this.isCorrectAnswerChosen = true;
                }
                if (this.isOlympiad || this.isBattle || finishExample) {
                    this.nextExample();
                }
            },
            nextExample() {
                this.stopAnswerTimer();
                if (!this.isInfiniteAmountOfExamples && this.currentLevel === this.parameters.amountOfExamples - 1) {
                    this.finishGame();
                    return;
                }
                this.getExample();
                this.isCorrectAnswerChosen = false;
                this.amountLetters.value = '';
                this.amountLetters.disabled = false;
                this.amountSounds.value = '';
                this.amountSounds.disabled = false;
                this.amountSyllables.value = '';
                this.amountSyllables.disabled = false;
                this.currentLevel++;
                this.startAnswerTimer();
            },
            finishGame() {
                this.gameFinished = true;
                this.stopTimer();
                this.soundInstance = this.$createjs.Sound.play('gameDone');
                this.sendStat();
            },
            calculatePercent() {
                let total = this.answers.good + this.answers.bad;
                if (total > 0) {
                    return parseInt((this.answers.good / total) * 100);
                }
                return 0;
            },
            beforeGameRestart() {
                Object.assign(this, DEFAULT_DATA());
            },
            onChangeAmount(amountField, value) {
                if (+value > 99) value = 99;
                amountField.value = value;
                amountField.error = false;
            },
            clickEnter(event) {
                if (event.key === 'Enter' && !this.gameFinished && this.gameStarted && !this.isLoading) {
                    if (!this.isCorrectAnswerChosen) {
                        return this.processReply();
                    }
                    if (this.isCorrectAnswerChosen) {
                        return this.nextExample();
                    }
                }
            },
        },
        components: {
            CsLoader,
            CsButton,
            CalculatingAnswers,
        },
    };
</script>

<style lang="scss" scoped>
    @import '@/assets/sass/games/playbox.scss';

    .mobile-version {
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    .play-box__example {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-grow: 5;
        flex-direction: column;
    }

    .play-box__overflow-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .play-box__end-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .play-box__reaction-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        @include media($md) {
            flex-direction: row;
        }
    }

    .play-box__answers {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        @include media($lg) {
            font-size: 32px;
            line-height: 38px;
        }
        @include media($xl) {
            font-size: 42px;
            line-height: 50px;
        }
    }

    .play-box__answers--left {
        color: $hsl-color-green-58;
        margin-left: 20px;
        @include media($lg) {
            margin-left: 35px;
        }
    }

    .play-box__answers--right {
        color: $hsl-color-green-58;
        margin-right: 20px;
        @include media($lg) {
            margin-right: 35px;
        }
    }

    .play-box__answers--show-md {
        display: block;
    }

    .play-box__answers-container {
        display: flex;
    }

    .play-box__image {
        max-width: 100%;
        margin-bottom: 40px;
        @media screen and (max-width: 1200px) {
            height: 400px;
        }
    }

    .play-box__answer {
        margin: 10px;
        padding: 15px;
        border: 3px solid $hsl-color-gray-74;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .play-box__next-example-button {
        margin-top: 15px;
    }

    .play-box__game-content {
        display: flex;
        width: 100%;
        @media screen and (max-width: 800px) {
            flex-direction: column-reverse;
            align-items: center;
        }
        .play-box__center {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 30px;
            text-align: center;
            justify-content: center;
            .play-box__center-word {
                padding: 7px 15px;
                box-shadow: 1px 1px 8px #0000006b;
                border-radius: 14px;
                letter-spacing: 3px;
                font-size: 30px;
                font-weight: 600;
                @include media($sm) {
                    padding: 10px 20px;
                    letter-spacing: 4px;
                    font-size: 38px;
                }
                @include media($lg) {
                    letter-spacing: 5px;
                    font-size: 50px;
                }
            }
            .play-box__center-transcription {
                letter-spacing: 3px;
                font-size: 30px;
                font-weight: 500;
                @include media($sm) {
                    font-size: 40px;
                }
            }
            .play-box__input-container {
                display: grid;
                grid-template-columns: auto auto;
                align-items: center;
                justify-content: center;
                column-gap: 20px;
                row-gap: 10px;
                .input__label {
                    font-weight: 600;
                    font-size: 22px;
                    @include media($sm) {
                        font-size: 28px;
                    }
                }
                &::v-deep .cs-input {
                    width: 70px;
                    height: 55px;
                    text-align: center;
                    &.error {
                        border-color: red;
                    }
                    &:disabled {
                        border-color: green;
                    }
                }
            }
            .answer-button {
                width: fit-content;
            }
        }
        .game-info__block {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            @media screen and (max-width: 800px) {
                &::v-deep .game-info {
                    width: 100%;
                }
                &::v-deep .game-info__block {
                    flex-direction: row;
                    width: 100%;
                    justify-content: space-between;
                }
            }
        }
    }
</style>
